import {Button, ButtonGroup, closeCurrentDialog} from 'platform/components';
import {Space, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {DiscountConfirmationDecision} from '../types/DiscountConfirmationDecision';

interface DiscountConfirmationDialogContentProps extends TestIdProps {
  onDecision: (decision: DiscountConfirmationDecision) => void;
}

export function DiscountConfirmationDialogContent(props: DiscountConfirmationDialogContentProps) {
  const handleDecision = (decision: DiscountConfirmationDecision) => () => {
    props.onDecision(decision);
    closeCurrentDialog();
  };

  return (
    <>
      <VStack>
        <Text alternative>{i18n.t('entity.order.discountConfirmation.question')}</Text>
        <Space vertical={4} />
        <Text size="small" color="tertiary">
          • {i18n.t('entity.order.discountConfirmation.doNotApplyDescription')}
        </Text>
        <Text size="small" color="tertiary">
          • {i18n.t('entity.order.discountConfirmation.applyDescription')}
        </Text>
      </VStack>
      <Space vertical={4} />
      <ButtonGroup align="right">
        <Button
          variant="secondary"
          title={i18n.t('general.actions.discard')}
          onClick={handleDecision('discard')}
          data-testid={suffixTestId('discard', props)}
        />
        <Button
          variant="secondary"
          title={i18n.t('entity.order.discountConfirmation.doNotApply')}
          onClick={handleDecision('doNotApply')}
          data-testid={suffixTestId('doNotApply', props)}
        />
        <Button
          variant="primary"
          title={i18n.t('general.actions.apply')}
          onClick={handleDecision('apply')}
          data-testid={suffixTestId('apply', props)}
        />
      </ButtonGroup>
    </>
  );
}
